<script lang="ts">
	import { marketSortDirection, marketSortKey, markets } from '$lib/home/store';
	import type { Market, MarketSortKeys } from '$lib/types/market';
	import BigNumber from 'bignumber.js';
	export let sortKey: MarketSortKeys;
	export let header: string;
	export let justifyItems: string = 'justify-center';
	function setMarketSortKey() {
		if ($marketSortKey == sortKey) {
			if ($marketSortDirection == 'Ascending') {
				marketSortDirection.set('Descending');
			} else {
				marketSortDirection.set('Ascending');
			}
		} else {
			marketSortKey.set(sortKey);
			marketSortDirection.set('Descending');
		}
	}
</script>

<div
	class="text-fx-grey-300 text-xs text-center flex gap-1 {justifyItems} cursor-pointer whitespace-nowrap"
	on:click={setMarketSortKey}
	on:keydown={setMarketSortKey}
>
	{header} <img src="sort.png" alt="sort" class="w-3 h-3" />
</div>
